import { motion } from 'framer-motion';
import { FaXTwitter, FaLinkedin } from "react-icons/fa6";


const LinkedInIcon = () => <FaLinkedin className="text-white w-5 h-5" />;

const XIcon = () => <FaXTwitter className="h-5 w-5 text-white" />;

const socialLinks = [
  {
    name: 'LinkedIn',
    href: 'https://www.linkedin.com/company/anciledspm/',
    icon: LinkedInIcon,
    color: 'text-white'
  },
  {
    name: 'X',
    href: 'https://x.com/anciledspm',
    icon: XIcon,
    color: 'text-white'
  }
];

const SocialLinks = () => {
  return (
    <div className="flex space-x-4">
      {socialLinks.map((social) => {
        const Icon = social.icon;
        return (
          <motion.a
            key={social.name}
            href={social.href}
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
            className={`${social.color} hover:text-white transition-colors`}
          >
            <span className="sr-only">{social.name}</span>
            <Icon />
          </motion.a>
        );
      })}
    </div>
  );
};

export default SocialLinks; 